
import { useEffect } from "react";
import { AddClientForm } from "./AddClientForm";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";

interface AddClientModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AddClientModal({ isOpen, onClose }: AddClientModalProps) {
  const { isBetaTier, canAddClient, refreshPermissions } = usePermissionCheck();

  // Force refresh permissions when modal opens
  useEffect(() => {
    if (isOpen) {
      refreshPermissions();
    }
  }, [isOpen, refreshPermissions]);

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[900px] bg-background/80 backdrop-blur-2xl border-white/10 shadow-xl p-0">
        <DialogTitle className="sr-only">Add New Client</DialogTitle>
        <div className="bg-background/80 backdrop-filter backdrop-blur-2xl">
          {isBetaTier && !canAddClient ? (
            <div className="p-8 text-center text-white">
              <h2 className="text-xl font-semibold mb-2">Client Limit Reached</h2>
              <p className="opacity-70">
                Beta tier accounts are limited to 2 clients. 
                Please upgrade your account or remove an existing client.
              </p>
            </div>
          ) : (
            <AddClientForm onSuccess={onClose} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
